import type { ProductListItem } from "../types/Product";

export const getHiddenProductId = (
  product: Pick<ProductListItem, "upc" | "sku">
): string => product.upc?.trim() || product.sku?.trim() || "";

export const isProductHidden = (
  product: Pick<ProductListItem, "upc" | "sku">,
  hiddenProductIds: ReadonlySet<string>
): boolean => {
  const productId = getHiddenProductId(product);
  return productId !== "" && hiddenProductIds.has(productId);
};
